/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useMemberData } from '../context/MemberDataContext';

export function FormTitle() {
  const { data } = useMemberData();
  const { t } = useTranslation('user_data_confirmation');

  return (
    <div className="first-access-form-title-container" data-testid="first-access-form-title">
      <div className="first-access-form-title-title" data-testid="first-access-form-title-firstName">
        <h1>{t('user_data_correct').replace('[##]', data.firstName)}</h1>
      </div>

      <div className="first-access-form-title-description" data-testid="first-access-form-title-description">
        <span>{t('update_data_description')}</span>
      </div>
    </div>
  );
}
